export default __webpack_public_path__ + "static/media/Marvin.dda472c5.otf";